export var MappingMechanism = /*#__PURE__*/ function(MappingMechanism) {
    MappingMechanism["Automatic"] = "AUTOMATIC";
    MappingMechanism["PromptDuringProjectcreation"] = "PROMPT_DURING_PROJECT_CREATION";
    MappingMechanism["PromptDuringIssuecreation"] = "PROMPT_DURING_ISSUE_CREATION";
    MappingMechanism["Fixed"] = "FIXED";
    return MappingMechanism;
}({});
export var ProjectMappingMechanism = /*#__PURE__*/ function(ProjectMappingMechanism) {
    ProjectMappingMechanism["Fixed"] = "FIXED";
    ProjectMappingMechanism["PromptDuringIssueCreation"] = "PROMPT_DURING_ISSUE_CREATION";
    return ProjectMappingMechanism;
}({});
export var SourceType = /*#__PURE__*/ function(SourceType) {
    SourceType["Templates"] = "TEMPLATE";
    return SourceType;
}({});
export var ValidationError = /*#__PURE__*/ function(ValidationError) {
    ValidationError["IntegrationBadState"] = "INTEGRATION_SETTINGS_BAD_STATE";
    return ValidationError;
}({});
